import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { massForceDeleteValueItems } from "../../api/apiValueItems";
import parseError from "../../utils/parseError";

export function useForceDeleteAllValueItems() {
    const queryClient = useQueryClient();

    const { mutate: forceDeleteAllItemsMutate, isPending } = useMutation({
        mutationFn: massForceDeleteValueItems,
        onSuccess: (response) => {
            toast.success(response.message || "Force deleted successfully");
            queryClient.invalidateQueries({ queryKey: ["value-items"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to force delete value items");
        },
    });

    return { forceDeleteAllItemsMutate, isPending };
}
